module.exports = __webpack_public_path__ + "static/img/44.6bca4c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/44.png
// module id = McWJ
// module chunks = 0